import { 
  Tab, Tabs, Icon, Uploader, Tag, Overlay, Field, List,
  PullRefresh, Radio, Cell, CellGroup, RadioGroup, Picker,
  Swipe, SwipeItem, Button, Progress, Checkbox, Skeleton,
  Empty,
} from 'vant';
import Vue from 'vue'

Vue.component('Tab', Tab)
;[
  Icon,
  Tab,
  Tabs,
  Uploader,
  Tag,
  Overlay,
  Field,
  List,
  PullRefresh,
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  Picker,
  Swipe,
  SwipeItem,
  Button,
  Progress,
  Checkbox,
  Skeleton,
  Empty,
].forEach(comp => {
  Vue.component(comp.name, comp)
})